import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
declare let $: any;
@Component({
  selector: 'app-load-watch-list',
  templateUrl: './load-watch-list.component.html',
  styleUrls: ['./load-watch-list.component.css'],
})
export class LoadWatchListComponent implements OnInit {
  loadwatches: any[] = [];
  searchList: any[] = [];
  generatorStatus: any[] = [];
  fuelType: any[] = [];

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
  });

  addOrEditForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    iLoadWatch: new FormControl(''),
    strIMEI: new FormControl('', Validators.required),
    strName: new FormControl('', Validators.required),
    tiPoleCount: new FormControl('', Validators.required),
    strSerialNumber: new FormControl(''),
    strModel: new FormControl(''),
    strBrand: new FormControl(''),
    fRatedPowerKW: new FormControl('', Validators.required),
    iRatedVoltage: new FormControl('', Validators.required),
    tiPhaseCount: new FormControl('', Validators.required),
    strInstallDate: new FormControl(''),
    tiGeneratorStatus: new FormControl('', Validators.required),
    tiFuelType: new FormControl('', Validators.required),
    strExpireDate: new FormControl('', Validators.required),
    fFuelConsumptionPerHour: new FormControl('', Validators.required),

  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    this.fetchData();
    this.fetchGeneratorStatus();
    this.fetchFuleType();
  }

  fetchGeneratorStatus = async () => {
    this._other.Showspinner()
    const model = this._other.stringNumberToNumber(this.searchForm.value)

    const res = JSON.parse((await axios.post(`LoadWatch_GeneratorStatus_List`, model)).data.toString());
    this._other.nonespinner();

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    this.generatorStatus = res;


  }

  fetchData = async () => {
    let model = this.searchForm.value;

    this._other.Showspinner()
    let res = JSON.parse((await axios.post(`LoadWatch_List`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.loadwatches = this.searchList = res;


  }

  fetchFuleType = async () => {
    let model = this.searchForm.value;

    this._other.Showspinner()
    let res = JSON.parse((await axios.post(`LoadWatch_FuleType_List`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    this.fuelType = res;


  }

  filterList(val: any) {
    this.loadwatches = this.searchList.filter((el: any) => {
      return el.iLoadWatch.toString().includes(val.value) ||
        el.fRatedPowerKW.toString().includes(val.value) ||
        el.strName.includes(val.value) ||
        el.strModel.includes(val.value) ||
        el.strBrand.includes(val.value)
    });

    if (val.value.length == 0) {
      this.loadwatches = this.searchList;
    }
  }

  openModal(item?: any) {
    this._other.markAllAsUnTouched(this.addOrEditForm)

    if (item) {
      Object.keys(item).forEach((key) => {
        this.addOrEditForm.get(key)?.setValue(item[key])
      });

      $("#addLoadWatch").modal("show");
      this.addOrEditForm.enable();
    }

    else {
      this.addOrEditForm.patchValue({
        iLoadWatch: '',
        strIMEI: '',
        strName: '',
        strSerialNumber: '',
        tiPoleCount: '',
        strModel: '',
        strBrand: '',
        fRatedPowerKW: '',
        iRatedVoltage: '',
        tiPhaseCount: '',
        strInstallDate: '',
        tiGeneratorStatus: '',
        tiFuelType: '',
        strExpireDate: '',
        fFuelConsumptionPerHour: '',
      })

      this.addOrEditForm.disable();
      this.addOrEditForm.controls['strIMEI'].enable();

      $("#addLoadWatch").modal("show")
    }

  }

  removeItem = async (item: any, index: number) => {
    $.confirm({
      title: `آیا از حذف اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "حذف",
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: async () => {
            var model = {
              iSystemUser: this._gurd.decrypt(window.localStorage.getItem('ID')!),
              strSession: this._gurd.decrypt(localStorage.getItem('Session')!),
              strIMEI: item.strIMEI
            }

            this._other.Showspinner();
            const resp = await axios.post(`LoadWatch_Delete`, model);
            this._other.nonespinner();
            let res = JSON.parse(resp.data);

            if (res.ISSessionExpired == true) {
              this._tooltip.showError('لطفا وارد سیستم شوید');
              this._other.removeLocalStorage();
              this._router.navigate(['login'], { queryParams: { error: '3' } });
              return;
            }

            if (res.iResult == 0) {
              return this._tooltip.showError(res.strError);
            }

            this.loadwatches.splice(index, 1)
            this._tooltip.showSuccess("با موفقیت حذف شد");
          }

        },
        cancel: {
          text: "لغو",
        }
      }
    });
  }

  verifyIMEI = async () => {
    const strIMEI = this.addOrEditForm.controls['strIMEI'].value
    if (strIMEI == '') {
      this._tooltip.showError('شناسه دیزل را به درستی وارد کنید!')
      return
    }

    this._other.Showspinner();
    const session = encodeURIComponent(this._gurd.decrypt(window.localStorage.getItem('Session')!));
    const resp = await axios.post(`GetMobile?iSystemUser=${this._gurd.decrypt(window.localStorage.getItem('ID')!)}&strIMEI=${strIMEI}&strSession=${session}`);
    this._other.nonespinner();

    if (resp.data.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است!');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '94' } });
      return;
    }

    this.addOrEditForm.enable();
    this._other.markAllAsUnTouched(this.addOrEditForm)

    if (resp.data.iResult == 1) {
      // console.log(resp.data);
      this._tooltip.showSuccess('شما می‌توایند اطلاعات را ویرایش کنید');

      this.addOrEditForm.patchValue({
        strName: resp.data.strFullName,
        strSerialNumber: '',
        strModel: '',
        strBrand: '',
        fRatedPowerKW: '',
        iRatedVoltage: '',
        tiPhaseCount: '',
        strInstallDate: '',
        tiGeneratorStatus: '',
        tiFuelType: '',
        strExpireDate: resp.data.strValidDate,
        fFuelConsumptionPerHour: '',
      })
    }

    else {
      this._tooltip.showSuccess('ثبت خودرو بلامانع است.')
    }

  }

  submitForm = async () => {
    if (this.addOrEditForm.invalid) {
      this._other.markAllAsTouched(this.addOrEditForm);
      this._tooltip.showError('موارد ضروری  را با دقت تکمیل کنید')
      return;
    }

    const model = this._other.stringNumberToNumber(this.addOrEditForm.value);

    this._other.Showspinner()
    let res = JSON.parse((await axios.post(`LoadWatch_SaveEdit`, model)).data.toString());
    this._other.nonespinner();

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    this._tooltip.showSuccess('عملیات با موفقیت انجام شد.');
    $("#addLoadWatch").modal("hide");

    this.fetchData();

  }

  showInMap(item: any) {

    if (!item.fLat || !item.fLon){
      return this._tooltip.showError('نتیجه ایی یافت نشد!');
    }

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this._gurd.encrypt(JSON.stringify([item])));

    window.open('/emdadran/search-requests/map', '_blank')
  }

  showAllInMap() {

    if (!this.loadwatches.length) return this._tooltip.showError('نتیجه ایی یافت نشد!');

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this._gurd.encrypt(JSON.stringify(this.loadwatches)));

    window.open('/emdadran/search-requests/map', '_blank')

  }


}
